import { Column, Entity, PrimaryGeneratedColumn } from "typeorm";

@Entity("complexity")
export class Complexity {
  @PrimaryGeneratedColumn({ type: "int", name: "id" })
  id: number;

  @Column("varchar", { name: "complexity", length: 50, default: () => "''" })
  complexity: string;

  @Column("tinyint", { name: "estatus", default: () => "'1'" })
  estatus: number;

  @Column("varchar", { name: "timestamp", length: 20, default: () => "''" })
  timestamp: string;
}
